<dx-data-grid
  [dataSource]="groups"
  keyExpr="id"
  [showBorders]="true"
  [columnAutoWidth]="true"
  [hoverStateEnabled]="true"
  height="100%"
  (onToolbarPreparing)="onToolbarPreparing($event)">
  <dxo-paging [enabled]="false"></dxo-paging>
  <dxo-pager [visible]="false"></dxo-pager>
  <dxo-scrolling mode="standard"></dxo-scrolling>

  <dxi-column dataField="name" caption="Name"></dxi-column>
  <dxi-column dataField="contact_name" caption="Contact"></dxi-column>
  <dxi-column dataField="contact_email_address" caption="Email"></dxi-column>
  <dxi-column dataField="contact_phone" caption="Phone"></dxi-column>

  <dxi-column type="buttons" caption="Actions" [width]="120">
    <dxi-button hint="Edit" icon="edit" [onClick]="onEditClick"></dxi-button>
    <dxi-button hint="Delete" icon="trash" [onClick]="onDeleteClick"></dxi-button>
  </dxi-column>
</dx-data-grid>
